import React, { useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';
import PropTypes from 'prop-types';
var I18nProvider = function I18nProvider(_ref) {
  var locale = _ref.locale,
    children = _ref.children,
    i18next = _ref.i18next;
  useEffect(function () {
    i18next.changeLanguage(locale);
  }, [locale]);
  return /*#__PURE__*/React.createElement(I18nextProvider, {
    i18n: i18next
  }, children);
};
I18nProvider.propTypes = {
  i18next: PropTypes.object,
  locale: PropTypes.string,
  children: PropTypes.element
};
I18nProvider.defaultProps = {
  i18next: {
    changeLanguage: function changeLanguage() {}
  },
  locale: 'nl',
  children: null
};
export default I18nProvider;